import { CodatState, SnackBar } from "./ui-state";

export enum UIActionTypeEnum {
  SET_PROGRESS = "SET_PROGRESS",
  SET_SNACK_BAR = "SET_SNACK_BAR",
  INCREASE_CURRENT_STEP_INDEX = "INCREASE_CURRENT_STEP_INDEX",
  DECREASE_CURRENT_STEP_INDEX = "DECREASE_CURRENT_STEP_INDEX",
  SET_CURRENT_STEP_INDEX = "SET_CURRENT_STEP_INDEX",
  SET_CODAT_CONNECTION = "SET_CODAT_CONNECTION",
  SET_CHECK_INTEGRATION= "SET_CHECK_INTEGRATION",
  SET_DOCUMENT_UPLOAD_BACK= "SET_DOCUMENT_UPLOAD_BACK",
  SET_DISABLE_BUTTON_CHECK= "SET_DISABLE_BUTTON_CHECK", 
}

export type UIAction = {
  type: UIActionTypeEnum.SET_PROGRESS;
  progress: boolean;
} | {
  type: UIActionTypeEnum.SET_SNACK_BAR;
  snackBar: SnackBar;
} | {
  type: UIActionTypeEnum.INCREASE_CURRENT_STEP_INDEX;
} | {
  type: UIActionTypeEnum.SET_CURRENT_STEP_INDEX;
  step: number;
} | {
  type: UIActionTypeEnum.DECREASE_CURRENT_STEP_INDEX;
} | {
  type: UIActionTypeEnum.SET_CODAT_CONNECTION;
  codatState: CodatState;
} | {
  type: UIActionTypeEnum.SET_CHECK_INTEGRATION;
  checkIntegration: boolean;
} | {
  type: UIActionTypeEnum.SET_DOCUMENT_UPLOAD_BACK;
  documentUploadBack: boolean;
} | {
  type: UIActionTypeEnum.SET_DISABLE_BUTTON_CHECK;
  disableButton: boolean;
}

export type DispatchType = (args: UIAction) => UIAction

// export function setProgress(progress: boolean): UIAction {
//   return {
//     type: UIActionTypeEnum.SET_PROGRESS,
//     progress
//   };
// }

export function setCodatState(codatState: CodatState): UIAction {
  return {
    type: UIActionTypeEnum.SET_CODAT_CONNECTION,
    codatState
  };
}
export function setSnackBar(snackBar: SnackBar): UIAction {
  return {
    type: UIActionTypeEnum.SET_SNACK_BAR,
    snackBar
  };
}
export function setCheckIntegration(checkIntegration: boolean): UIAction {
  return {
    type: UIActionTypeEnum.SET_CHECK_INTEGRATION,
    checkIntegration
  };
}
export function increaseCurrentStepperIndex(): UIAction {
  return {
    type: UIActionTypeEnum.INCREASE_CURRENT_STEP_INDEX,
  };
}

export function decreaseCurrentStepperIndex(): UIAction {
  return {
    type: UIActionTypeEnum.DECREASE_CURRENT_STEP_INDEX,
  };
}
export function setCurrentStepperIndex(step: number): UIAction {
  return {
    type: UIActionTypeEnum.SET_CURRENT_STEP_INDEX,
    step
  };
}
export function setDocumentUploadBack(documentUploadBack: boolean): UIAction {
  return {
    type: UIActionTypeEnum.SET_DOCUMENT_UPLOAD_BACK,
    documentUploadBack
  };
}
export function setDisableButtonCheck(disableButton: boolean): UIAction {
  return {
    type: UIActionTypeEnum.SET_DISABLE_BUTTON_CHECK,
    disableButton
  };
}